import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { getUpsellItems } from "@/data/upsellMap";

const fmt = (n) => n.toLocaleString("en-NZ", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export function CompleteYourBuild({ productPath }) {
  const items = getUpsellItems(productPath);
  if (!items?.length) return null;

  return (
    <div data-testid="complete-your-build" className="mt-14 text-left">
      <p className="overline mb-2">— Complete Your Build</p>
      <h2 className="font-display text-2xl md:text-3xl text-white mb-6 leading-tight">
        GEAR THAT PAIRS WELL <span className="text-[var(--brand-primary)]">WITH YOUR ORDER.</span>
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {items.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            data-testid={`upsell-item-${item.to}`}
            className="group relative block overflow-hidden border border-[var(--border-default)] hover:border-[var(--brand-primary)] transition-colors bg-[var(--bg-secondary)]"
          >
            <div className="aspect-[4/3] overflow-hidden relative">
              <img src={item.thumb} alt={item.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-display text-sm md:text-base text-white leading-tight tracking-wide line-clamp-2">{item.name.toUpperCase()}</h3>
                <div className="flex items-end justify-between gap-3 mt-2">
                  <p className="font-display text-base text-[var(--brand-primary)] leading-none">
                    {item.priceFrom ? "FROM " : ""}${fmt(item.price)}
                  </p>
                  <span className="inline-flex items-center gap-1 text-[10px] font-mono uppercase tracking-[0.2em] text-white group-hover:text-[var(--brand-primary)] transition-colors">
                    View <ArrowUpRight size={11} />
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
